var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProperty = function SvgProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.556,
    height: 39.945,
    viewBox: "0 0 35.556 39.945"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.444,
    height: 4.444,
    x: 11.556,
    y: 35.501,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.596.437 14.869 7.586a2 2 0 0 1 1.09 1.782v21.653a4 4 0 0 1-4 4L24 35.457V32.39a4 4 0 0 0-3.8-3.995l-.2-.005h-4.444a4 4 0 0 0-4 4l-.001 3.067H4a4 4 0 0 1-4-4V9.806a2 2 0 0 1 1.091-1.782L15.96.437a4 4 0 0 1 3.636 0z",
    opacity: 0.601
  }))));
};
export default SvgProperty;